import React from 'react'
import { License } from './utils'
import styled from 'styled-components'
import RdnaText from '@ringdna/common/src/components/RdnaText'
import { flags, isFlagged } from '@ringdna/common/src/utils/feature-flag/featureFlag'

type Props = {
  availableLicenses: { [key: string]: number }
}

export default function AvailableLicenses({ availableLicenses }: Props) {
  return (
    <>
      <Row>
        <RdnaText bold variant={'body2'}>
          {'Available Licenses'}
        </RdnaText>
      </Row>
      <Row>
        <div>
          <RdnaText bold>{`${License.INTELLIGENT_DIALER}: `}</RdnaText>
          <RdnaText>{availableLicenses.dialerLicense}</RdnaText>
        </div>
        <div>
          <RdnaText bold>{`${License.CONVERSATION_AI}: `}</RdnaText>
          <RdnaText>{availableLicenses.caiLicense}</RdnaText>
        </div>
        <div>
          <RdnaText bold>{`${License.MOMENTS}: `}</RdnaText>
          <RdnaText>{availableLicenses.momentsLicense}</RdnaText>
        </div>
        <div>
          <RdnaText bold>{`${License.GUIDED_SELLING}: `}</RdnaText>
          <RdnaText>{availableLicenses.gsLicense}</RdnaText>
        </div>
      </Row>
      <Row>
        {isFlagged(flags.v299_REV_2816) && (
          <div>
            <RdnaText bold>{`${License.REVENUE_AI}: `}</RdnaText>
            <RdnaText>{availableLicenses.revenueAILicense}</RdnaText>
          </div>
        )}
        <div>
          <RdnaText bold>{`${License.CALENDAR}: `}</RdnaText>
          <RdnaText>{availableLicenses.calendarLicense}</RdnaText>
        </div>
        <div>
          <RdnaText bold>{`${License.ADMIN}: `}</RdnaText>
          <RdnaText>{availableLicenses.adminLicense}</RdnaText>
        </div>
      </Row>
    </>
  )
}

const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin-top: ${({ theme }) => theme.spacing}px;
  margin-bottom: ${({ theme }) => theme.spacing}px;
`
